<template>
  <span>
    <basket-validation class="mb-3"></basket-validation>
    <a
      @click="track()"
      v-editable="blok"
      :href="url"
      :target="blok.cta_target"
      :class="classes"
    >{{ blok.cta_label }}</a>
  </span>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";

import BasketValidation from "./basket/BasketValidation";

export default {
  name: "legacy-cta",
  props: ["blok"],
  methods: {
    track: function() {
      if (this.ready) {
        try {
          gtag("event", "cta_click", {
            event_label: this.$props.blok._uid
          });
        } catch (e) {
          console.warn(e);
        }
      }
    }
  },
  components: {
    BasketValidation
  },
  computed: {
    ...mapState({
      meal_preferences: state => state.profile.meal_preferences,
      basket: state => state.basket
    }),
    ...mapGetters({
      ready: "basket/ready"
    }),
    classes: function() {
      return [
        "cta-button",
        this.$props.blok.cta_type ? `btn-${this.$props.blok.cta_type}` : "",
        !this.ready ? "disabled" : ""
      ];
    },
    url: function() {
      const f = this.$options.filters;
      return this.ready
        ? f.appendLegacyOnboardingQuery(
            f.formatSbInternalLink(this.blok.cta.cached_url),
            this.meal_preferences,
            this.basket
          )
        : "javascript://";
    }
  }
};
</script>